<template>
    <!-- Header Area Start Here -->
    <header class="header header-mobile">

        <div id="rt-sticky-placeholder"></div>

        <div id="header-menu" class="header-menu menu-layout1 pd-x-45" >
            <div class="container-fluid" >
                <div class="row d-flex align-items-center header-container" >
                    <div class="col-3" >
                        <div class="logo-area" >
                            <router-link to="/" class="temp-logo text-black" style="font-weight: bold">
                                <img src="icons/logo.png" alt="logo" style="width: 40px;height: 40px;margin-right: 10px" class="img-fluid mt-3" >
                                NORB
                            </router-link>
                            <router-link to="/" class="sticky-logo text-white" style="font-weight: bold">
                                <img src="icons/logo.png" alt="logo" style="width: 40px;height:40px;margin-right: 10px;border-radius: 10px" class="img-fluid bg-white mt-3" >
                                NORB
                            </router-link>
                            <!--<a href="index.html" class="sticky-logo">-->
                                <!--<img src="img/sticky-logo1.png" alt="logo" class="img-fluid">-->
                            <!--</a>-->
                        </div>
                    </div>
                    <div class="col-9 d-flex justify-content-end" >
                        <div class="header-action-layout1">
                            <ul>
                                <li class="offcanvas-menu-trigger-wrap">
                                    <button @click="$emit('canToggleOffCanvas')" type="button" class="offcanvas-menu-btn menu-status-open ">
                                            <span class="btn-icon-wrap">
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                            </span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!--<canvas-component />-->

    </header>
    <!-- Header Area End Here -->
</template>

<script>
    import CanvasComponent from "./CanvasComponent";
    export default {
        name: "HeaderComponentMobile",
        components: {CanvasComponent},
        props: ['canHideTopSmallBar']
    }
</script>

<style scoped>
    @media only screen and (max-width: 991px) {
        header.header {
            display: block;
        }
    }

    @media only screen and (min-width: 992px) {
        header.header {
            display: none;
        }
    }
</style>